export default __webpack_public_path__ + "static/media/interquim.e59a7ed0.jpg";